import { React, useState } from "react";
import axios from "axios";
import Loader from "../../Global/Loader";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEdit } from 'react-icons/fa';
import { getDisplayValue } from "../../../utils/displayValue";


function InProcessApplications({ applications = [], consultants = [], formatDate, fetchConsultants, fetchApplications }) {
    const [selectedConsultantId, setSelectedConsultantId] = useState("");
    const [selectedApplicationId, setSelectedApplicationId] = useState("");
    const [isAccepted, setIsAccepted] = useState(false);
    const [isRejected, setIsRejected] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [error, setError] = useState("");

    const navigate = useNavigate();

    const handleConsultantChange = (consultantId, applicationId) => {
        setSelectedConsultantId(consultantId);
        setSelectedApplicationId(applicationId);
    };


    // Filter applications with remarks
    const applicationsWithRemarks = applications.filter((application) => application.remarks);

    // Filter applications without remarks
    applications = applications.filter((application) => !application.remarks);

    const handleSave = async (applicationId) => {
        if (!selectedConsultantId) {
            alert('Please select a consultant first');
            return;
        }

        try {
            setLoading(true);
            if (selectedConsultantId === 'admin') {
                await axios.patch(
                    `${process.env.REACT_APP_BASE_URL}/application/update/${applicationId}`,
                    {
                        consultantName: 'Admin',
                        status: "In Process"
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        }
                    }
                );
            } else {
                await axios.patch(
                    `${process.env.REACT_APP_BASE_URL}/application/update/${applicationId}`,
                    {
                        consultantId: selectedConsultantId,
                        status: "In Process"
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        }
                    }
                );
            }
            fetchConsultants();
            fetchApplications();
            setIsSubmitted(true);
        } catch (error) {
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    const handleApprove = async (application) => {
        try {
            setLoading(true)
            const response = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/application/update/${application._id}`,
                {
                    status: 'Accepted',
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    }
                },
            );
            fetchConsultants();
            fetchApplications();
            setIsAccepted(true);

        } catch (error) {
            alert(error?.response?.data?.message || "Error updating application")
        } finally {
            setLoading(false);
        }
    };


    const handleReject = async (application) => {

        try {
            setLoading(true);
            const response = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/application/update/${application._id}`,
                {
                    status: 'Rejected'
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    }
                },
            );
            fetchConsultants();
            fetchApplications();
            setIsRejected(true);

        } catch (error) {
            // console.error('Error rejecting consultation:', error);
            alert(error?.response?.data?.message || "Error updating application")
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loader />}
            {isSubmitted && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
                        <h2 className="text-lg font-semibold text-gray-700 mb-4">Success!</h2>
                        <h4 className="text-sm text-gray-600 mb-6">
                            Consultant has been assigned successfully to the Application.
                        </h4>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={() => setIsSubmitted(null)}
                                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                            >
                                Okay
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isAccepted && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
                        <h2 className="text-lg font-semibold text-gray-700 mb-4">Success!</h2>
                        <h4 className="text-sm text-gray-600 mb-6">
                            The Application has been accepted successfully.
                        </h4>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={() => setIsAccepted(false)}
                                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                            >
                                Okay
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isRejected && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
                        <h2 className="text-lg font-semibold text-gray-700 mb-4">Success!</h2>
                        <h4 className="text-sm text-gray-600 mb-6">
                            The Application has been rejected successfully.
                        </h4>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={() => setIsRejected(false)}
                                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                            >
                                Okay
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {error && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
                        <h2 className="text-lg font-semibold text-gray-700 mb-4">Something went wrong!</h2>
                        <h4 className="text-sm text-gray-600 mb-6">
                            We encountered an issue while processing your request. Please try again later. If the problem persists, contact support.
                        </h4>
                        <div className="flex justify-end space-x-4">
                            <button
                                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                            >
                                Okay
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="flex flex-wrap space-x-6">
                <div className="flex flex-col space-y-6 w-full">
                    {/* All Applications */}
                    <div className="px-10 py-6 bg-white rounded ">
                        <h2 className="text-lg font-semibold text-gray-700 mb-4">Newly Assigned Applications</h2>
                        <table className="w-full table-auto border-t border-b border-gray-300">
                            <thead>
                                <tr className="border-b border-gray-300">
                                    <th className="px-4 py-2 text-center text-gray-400">Application ID</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Student Name</th>
                                    <th className="px-4 py-2 text-center text-gray-400">University</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Country</th>
                                    <th className="px-4 py-2 text-center text-gray-400">City</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Date of Submission</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {applications.length > 0 ? applications.map((application) => (
                                    <tr
                                        key={application._id}
                                        className="border-b border-gray-300 cursor-pointer text-center"
                                    >
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.customApplicationId)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.fullName)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.university)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.country)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.city)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{formatDate(application.applicationDate) || 'N/A'}</td>
                                        
                                        <td className="py-4 text-sm font-thin flex items-center justify-center">
                                            <button
                                                onClick={() => navigate(`/consultant/application-form`, { state: { id: application._id } })}
                                                className="p-1 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
                                                title="Save"
                                            >
                                                <FaEdit className="size-4" />
                                            </button>
                                        </td>
                                    </tr>
                                )) : <tr><td colSpan={8} className="text-center text-gray-700 py-4">No data available</td></tr>}
                            </tbody>
                        </table>
                    </div>

                    {/* Applications with Remarks */}
                    <div className="px-10 py-6 bg-white rounded ">
                        <h2 className="text-lg font-semibold text-gray-700 mb-4">Reviewed Applications</h2>
                        <table className="w-full table-auto border-t border-b border-gray-300">
                            <thead>
                                <tr className="border-b border-gray-300">
                                    <th className="px-4 py-2 text-center text-gray-400">Application ID</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Student Name</th>
                                    <th className="px-4 py-2 text-center text-gray-400">University</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Country</th>
                                    <th className="px-4 py-2 text-center text-gray-400">City</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Date of Submission</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {applicationsWithRemarks.length > 0 ? applicationsWithRemarks.map((application) => (
                                    <tr
                                        key={application._id}
                                        className="border-b border-gray-300 cursor-pointer text-center"
                                    >
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.customApplicationId)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.fullName)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.university)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.country)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.city)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{formatDate(application.applicationDate) || 'N/A'}</td>
                                        <td className="py-4 text-sm font-thin flex items-center justify-center">
                                            <button
                                                onClick={() => navigate(`/consultant/application-form`, { state: { id: application._id } })}
                                                className="p-1 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
                                                title="Save"
                                            >
                                                <FaEye className="size-4" />
                                            </button>
                                        </td>
                                    </tr>
                                )) : <tr><td colSpan={8} className="text-center text-gray-700 py-4">No data available</td></tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default InProcessApplications;
